"use client";

import React, { useState, lazy, Suspense } from "react";
import { University } from "@/types/university";
import PopupMeassge from "./PopupMeassge";
import Loader from "@/components/shared/Loader";

const AboutUniversity = lazy(() => import("./AboutUniversity"));
const ExistedFaculty = lazy(() => import("./ExistedFaculty"));
const Location = lazy(() => import("./Location"));
const ApplicationRequirements = lazy(() => import("./ApplicationRequirements"));
const MinimumLimits = lazy(() => import("./MinimumLimits"));
const Expenses = lazy(() => import("./Expenses"));
const AdmissionRequirements = lazy(() => import("./AdmissionRequirements"));

interface NavigationMenuProps {
  university: University;
  locale: "ar" | "en";
}

const navigationText: Record<NavigationMenuProps["locale"], string[]> = {
  ar: [
    "عن الجامعة",
    "الكليات",
    "التواصل",
    "متطلبات التقديم",
    "شروط القبول",
    "الحدود الدنيا",
    "المصروفات",
  ],
  en: [
    "About the University",
    "Faculties",
    "Location",
    "Admission Requirements",
    "Admission Criteria",
    "Minimum Scores",
    "Tuition Fees",
  ],
};

const NavigationMenu: React.FC<NavigationMenuProps> = ({
  locale,
  university,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentText = navigationText[locale];

  const renderContent = () => {
    switch (currentIndex) {
      case 0:
        return (
          <AboutUniversity
            name={university.name}
            advantages={university.advantages}
            description={university.description}
          />
        );
      case 1:
        return (
          <ExistedFaculty
            faculties={university.faculties}
            image={university.image}
            images={university.images}
            name={university.name}
            type={university.type}
            // location={university.location}
            map_links={university.map_links}
          />
        );
      case 2:
        return (
          <Location
            email={university.email}
            // location={university.location}
            map_links={university.map_links}
            // current_branch={university.current_branch}
            phone_number={university.phone_number}
            website_url={university.website_url}
          />
        );
      case 3:
        return (
          <ApplicationRequirements
            application_requirement={university.application_requirement}
            name={university.name}
            locale={locale}
          />
        );
      case 4:
        return (
          <AdmissionRequirements
            admission_requirement={university.admission_requirement}
            name={university.name}
          />
        );
      case 5:
        return (
          <MinimumLimits
            minimum_limits={university.minimum_limits}
            name={university.name}
          />
        );
      case 6:
        return (
          <Expenses name={university.name} expenses={university.expenses} />
        );

      default:
        return null;
    }
  };

  return (
    <div className="container relative">
      <PopupMeassge />
      <div className="bg-white p-5 rounded-[10px] flex flex-col gap-5">
        <div className="flex items-center gap-3 justify-center flex-wrap border-b border-[#EBEBEB] pb-5 mb-5">
          {currentText.map((item, index) => (
            <p
              key={index}
              className={`cursor-pointer text-center ${
                currentIndex === index
                  ? "text-18 text-white font-medium bg-primaryColor py-2 px-5 rounded-[10px]"
                  : "text-18 text-darkText font-medium bg-white py-2 px-5 rounded-[10px]"
              }`}
              onClick={() => {
                setCurrentIndex(index);
              }}
            >
              {item}
            </p>
          ))}
        </div>
        <Suspense fallback={<Loader />}>{renderContent()}</Suspense>
      </div>
    </div>
  );
};

export default NavigationMenu;
